import { render, staticRenderFns } from "./pay-success.vue?vue&type=template&id=7f5c27e5&scoped=true&"
import script from "./pay-success.vue?vue&type=script&lang=js&"
export * from "./pay-success.vue?vue&type=script&lang=js&"
import style0 from "./pay-success.scss?vue&type=style&index=0&id=7f5c27e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5c27e5",
  null
  
)

export default component.exports